import { fetchPostsStart, fetchPostsSuccess, fetchPostsFailure } from "./reducer";
import { getAllPosts, createPostService, updatePostService, deletePostService, getPostByIdService, bulkDeletePosts as bulkDeletePostsService } from "../../helpers/apis";
import axios from "axios";

export const fetchAllPosts = (params = {}) => async (dispatch) => {
  dispatch(fetchPostsStart());

  console.log("📡 Fetching posts with params:", params);

  try {
    const backendParams = {
      page: params.page || 1,
      limit: params.limit || 10,
      search: params.search ? params.search.trim() : "",
      orderBy: params.orderBy || "createdAt",
      order: params.order || "desc",
    };

    console.log("📤 Backend params:", backendParams);
    console.log("🔑 Authorization header:", axios.defaults.headers.common["Authorization"] ? "Set" : "Not set");

    const response = await getAllPosts(backendParams);

    console.log("📥 Response received:", response);

    let posts = [];
    let totalRows = 0;
    let currentUserPostCount = 0;

    // Robust data extraction
    if (response) {
      // 1. Try to find the posts array
      if (Array.isArray(response.data)) {
        posts = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        posts = response.data.data;
      } else if (response.data && Array.isArray(response.data.docs)) {
        posts = response.data.docs;
      } else if (response.data && Array.isArray(response.data.posts)) {
        posts = response.data.posts;
      } else if (Array.isArray(response)) {
        posts = response;
      }

      // 2. Try to find total count
      totalRows = response.totalData ||
        response.total ||
        response.totalDocs ||
        response.count ||
        (response.data && response.data.total) ||
        posts.length;

      // 3. Try to find user specific count
      currentUserPostCount = response.currentUserPostCount ||
        (response.data && response.data.currentUserPostCount) ||
        0;

      console.log("✅ Posts extracted:", {
        postsCount: posts.length,
        totalRows,
        currentUserPostCount,
        firstPost: posts[0] ? 'Found' : 'None'
      });
    } else {
      console.warn("⚠️ Response is empty or null");
    }

    dispatch(fetchPostsSuccess({ posts, totalRows, currentUserPostCount }));
  } catch (err) {
    console.error("❌ Error fetching posts:", err);
    console.error("Error details:", {
      message: err.message,
      response: err.response,
      status: err.response?.status,
      data: err.response?.data
    });
    dispatch(fetchPostsFailure(err.message || "Failed to fetch posts"));
  }
};

export const createPost = (data) => async () => {
  try {
    let res;

    if (data.mediaUrl) {
      const postData = {
        description: data.description,
        mediaType: data.mediaType || "image",
        mediaUrl: data.mediaUrl
      };
      res = await createPostService(postData);
    } else {
      const formData = new FormData();
      formData.append("description", data.description);
      formData.append("mediaType", data.mediaType || "image");
      if (data.media instanceof File) {
        formData.append("media", data.media);
      }
      res = await createPostService(formData);
    }

    return res?.status === 1
      ? { ok: true, data: res.data }
      : { ok: false, message: res?.message };
  } catch (err) {
    return { ok: false, message: err.message };
  }
};

export const updatePost = (id, data) => async () => {
  try {
    let res;

    if (data.mediaUrl) {
      const postData = {
        description: data.description,
        mediaType: data.mediaType || "image",
        mediaUrl: data.mediaUrl
      };
      res = await updatePostService(id, postData);
    } else if (data.media instanceof File) {
      const formData = new FormData();
      formData.append("description", data.description);
      formData.append("mediaType", data.mediaType || "image");
      formData.append("media", data.media);
      res = await updatePostService(id, formData);
    } else {
      const postData = {
        description: data.description,
        mediaType: data.mediaType || "image",
        mediaUrl: data.media
      };
      res = await updatePostService(id, postData);
    }

    return res?.status === 1
      ? { ok: true, data: res.data }
      : { ok: false, message: res?.message };
  } catch (err) {
    return { ok: false, message: err.message };
  }
};

export const deletePost = (id) => async () => {
  try {
    await deletePostService(id);
    return { ok: true };
  } catch (err) {
    return { ok: false, message: err.message };
  }
};

export const getPostById = (id) => async () => {
  try {
    const res = await getPostByIdService(id);
    return res?.status === 1
      ? { ok: true, data: res.data }
      : { ok: false, message: res?.message };
  } catch (err) {
    return { ok: false, message: err.message };
  }
};

export const bulkDeletePosts = (postIds) => async (dispatch) => {
  try {
    const res = await bulkDeletePostsService(postIds);

    if (res?.status === 1) {
      return {
        ok: true,
        message: res?.message,
        deletedCount: res?.data?.deletedCount,
      };
    } else {
      return {
        ok: false,
        message: res?.message || "Failed to delete posts",
      };
    }
  } catch (err) {
    return { ok: false, message: err.message };
  }
};